<template>
  <div data-height="52" class="header_bot">
    <div class="header_bot_outer">
      <div class="header_bot_inner">
        <div class="header_bot_inner-box">
          <Catalog />
          <!-- <span class="header_bot_border_top"></span> -->
          <div class="bot_nav_wrap">
            <nav>
              <div class="menu-primary-navigation-container">
                <MenuNode :nodes="filteredMenuNodes" />
              </div>
            </nav>
          </div>
          <RepairCatalog />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MenuNode from '@/components/header/MenuNode'
import MenuMixin from '@/components/header/MenuMixin'
import Catalog from '@/components/header/Catalog'
import RepairCatalog from '@/components/repair/RepairCatalog'
import { mapState } from 'vuex'

export default {
  name: 'HeaderMenu',
  components: { MenuNode, Catalog, RepairCatalog },
  mixins: [MenuMixin],
  computed: {
    ...mapState(['menu']),
    filteredMenuNodes() {
      if (this.menu && Array.isArray(this.menu)) {
        const menuNodesMapping = Object.fromEntries(
          this.menuNodes.map((node) => [node.slug, node])
        )
        const list = []

        this.menu.forEach(({ checked, slug }) => {
          if (checked && menuNodesMapping[slug]) {
            list.push(menuNodesMapping[slug])
          }
        })
        return list
      } else {
        return this.menuNodes
      }
    },
  },
}
</script>

<style>
.header_bot_inner-box {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  position: relative;
}
.header_bot .header_bot_inner-box .bot_nav_wrap {
  justify-content: flex-start;
}
</style>
